import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import { Request } from 'commons/utils/request'

import { TemplateManageSchema } from './TemplateManageSchema'

export const templateEditRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$id/edit',
    component: lazyRouteComponent(() => import('./TemplateManage')),
    validateSearch: (search) => TemplateManageSchema.parse(search),
    beforeLoad: ({ params, ...all }) => {
      if ('id' in params) return { ...all, flatDeps: { id: Number(params.id) } }
      else throw new NotFoundError()
    },
    loader: async (all) => {
      const {
        context: {
          flatDeps: { id },
          search: { copyFrom }
        }
      } = all
      return id
        ? Request.post(Request.urls.bank.documentTemplateEdit, { id })
        : copyFrom
          ? Request.post(Request.urls.bank.documentTemplateEdit, { id: copyFrom })
          : Request.post(Request.urls.bank.documentTemplateCreate)
    }
  })
